import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { schedulesService, CreateScheduleInput } from '../services/schedules';

const key = ['schedules'] as const;

export function useSchedules() {
  return useQuery({ queryKey: key, queryFn: () => schedulesService.list() });
}

export function useCreateSchedule() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateScheduleInput) => schedulesService.create(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: key }),
  });
}

export function useUpdateSchedule() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      data,
    }: {
      id: string;
      data: { cron?: string; enabled?: boolean; inputData?: Record<string, unknown> };
    }) => schedulesService.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: key }),
  });
}

export function useDeleteSchedule() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => schedulesService.remove(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: key }),
  });
}
